/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type KeyPointsContainer_KeyPoints_QueryVariables = {|
  postId?: ?string
|};
export type KeyPointsContainer_KeyPoints_QueryResponse = {|
  +postAnalytics: ?{|
    +id: string,
    +post_id: ?string,
    +news_points: ?$ReadOnlyArray<?string>,
  |}
|};
export type KeyPointsContainer_KeyPoints_Query = {|
  variables: KeyPointsContainer_KeyPoints_QueryVariables,
  response: KeyPointsContainer_KeyPoints_QueryResponse,
|};
*/


/*
query KeyPointsContainer_KeyPoints_Query(
  $postId: String
) {
  postAnalytics(postId: $postId) {
    id
    post_id
    news_points
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "postId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "postId",
        "variableName": "postId"
      }
    ],
    "concreteType": "PostAnalyticsNode",
    "kind": "LinkedField",
    "name": "postAnalytics",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "post_id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "news_points",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "KeyPointsContainer_KeyPoints_Query",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "KeyPointsContainer_KeyPoints_Query",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "fcf6ff8f3baf00ddfcdf11b903335c2e",
    "id": null,
    "metadata": {},
    "name": "KeyPointsContainer_KeyPoints_Query",
    "operationKind": "query",
    "text": "query KeyPointsContainer_KeyPoints_Query(\n  $postId: String\n) {\n  postAnalytics(postId: $postId) {\n    id\n    post_id\n    news_points\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '1027ccbe84f5883efa34c5755dac5600';

module.exports = node;
